import React, {useState} from "react";
import {Interactive} from "@react-three/xr";
import {gql} from "@apollo/client";
import {Container, Text} from "@react-three/uikit";
import {Button} from "@react-three/uikit-apfel";
import {apolloClient, AttachApolloClientLink, InitApolloLink, wsClient} from "../../../../Utils/LibIntegrations/Apollo.js";
import {observer_mgl_r3} from "../../../../Utils/ThreeJS/General.js";
import * as THREE from "three";
import {store} from "../../../../Store/index.js";

const c = (colorStr: string)=>{
	//return new THREE.Color(colorStr);
	return colorStr;
};

export const WSReconnectUI = observer_mgl_r3(()=>{
	// we only show this panel if the websocket is disconnected
	//if (store.wvc.webSocketConnected) return null;
	const vrState = store.main.tools.vr;

	return (
		<Container flexGrow={1} flexDirection="column">
			<Container flexDirection="row" gap={0.05} justifyContent="center">
				<Text fontSize={16} color="white" marginBottom={0.1}>
					WebSocket {store.wvc.webSocketConnected ? "connected" : "disconnected"}. (FD: {vrState.imageFramesDisplayed_duringRemoteSession})
				</Text>
			</Container>

			<Container flexDirection="row" gap={0.05} justifyContent="center">
				<VRButton text="DC1" backgroundColor={c("rgb(128,128,0)")} hover={{backgroundColor: c("rgb(255,255,0)")}} onClick={()=>{
					console.log("DC1 clicked", vrState.right_interactionMode); // test; making sure click-handling is always working (at one point, WS dc'ed, and no button changed anything!)
					if (vrState.right_interactionMode != "interact") return;
					wsClient.terminate();
				}}/>
				<VRButton text="DC2" backgroundColor={c("rgb(128,128,0)")} hover={{backgroundColor: c("rgb(255,255,0)")}} onClick={()=>{
					if (vrState.right_interactionMode != "interact") return;
					apolloClient.stop();
				}}/>
				<VRButton text="RI" backgroundColor={c("rgb(128,128,0)")} hover={{backgroundColor: c("rgb(255,255,0)")}} onClick={()=>{
					if (vrState.right_interactionMode != "interact") return;
					InitApolloLink();
					AttachApolloClientLink();
				}}/>
				<VRButton text="RC1" backgroundColor={c("rgb(128,128,0)")} hover={{backgroundColor: c("rgb(255,255,0)")}} onClick={()=>{
					if (vrState.right_interactionMode != "interact") return;
					apolloClient.reFetchObservableQueries(true);
				}}/>

				<VRButton text="Sub1" backgroundColor={c("rgb(0,0,128)")} hover={{backgroundColor: c("rgb(0,0,255)")}} onClick={()=>{
					if (vrState.right_interactionMode != "interact") return;
					const closeSub = wsClient.subscribe({query: ("subscription { _ping { pong } }")}, {
						next: data=>{
							//console.log("Ping", data);
							closeSub();
						},
						complete: ()=>{
							//console.log("Complete");
							closeSub();
						},
						error: error=>{
							//console.error("Error", error);
							closeSub();
						},
					});
				}}/>
				<VRButton text="Sub2" backgroundColor={c("rgb(0,0,128)")} hover={{backgroundColor: c("rgb(0,0,255)")}} onClick={()=>{
					if (vrState.right_interactionMode != "interact") return;
					const a = apolloClient.subscribe({query: gql("subscription { _ping { pong } }")});
					/*let b = a.subscribe(()=>{}, ()=>{});
					b.unsubscribe()*/
				}}/>
			</Container>
		</Container>
	);
});

type ButtonProps = React.ComponentProps<typeof Button>;
const VRButton = (props: {text: string, fontSize?: number, backgroundOpacity?: number} & Omit<ButtonProps, "label">)=>{
	const {text, fontSize = 16, backgroundOpacity = 1, ...rest} = props;
	return (
		<Button {...rest} backgroundOpacity={backgroundOpacity}>
			<Text fontSize={fontSize}>{text}</Text>
		</Button>
	);
};